import classNames from 'classnames';
import { ReactNode } from 'react';
import styles from './IconContainer.module.scss';

type IconContainerProps = {
  children: ReactNode;
  className?: string;
  crop?: 'squircle' | 'circle';
  size?: 'md';
};

const IconContainer = ({ children, className, crop = 'circle', size = 'md' }: IconContainerProps) => {
  return <span className={classNames(styles.container, styles[size], styles[crop], className)}>{children}</span>;
};

export default IconContainer;
